import { User } from "@/entities/user";

/**
 * Проверяет, есть ли у пользователя активная подписка
 * @param user - объект пользователя
 * @returns true если подписка активна, false если нет
 */
export const hasActiveSubscription = (user: User | null): boolean => {
  if (!user?.user?.subscription) {
    return false;
  }

  const subscription = user.user.subscription;
  
  // Если end_date равен null, это безлимитная подписка
  if (subscription.end_date === null) {
    return true;
  }

  // Проверяем, не истекла ли подписка
  const endDate = new Date(subscription.end_date);
  const now = new Date();
  
  return endDate > now;
};

/**
 * Получает информацию о подписке пользователя
 * @param user - объект пользователя
 * @returns объект с информацией о подписке или null
 */
export const getSubscriptionInfo = (user: User | null) => {
  if (!user?.user?.subscription) {
    return null;
  }

  return {
    serviceTitle: user.user.subscription.service_title,
    startDate: user.user.subscription.start_date,
    endDate: user.user.subscription.end_date,
    isUnlimited: user.user.subscription.end_date === null,
    isActive: hasActiveSubscription(user)
  };
};
